export default __webpack_public_path__ + "static/media/default_document_resized.ae209888.png";